export default {"src":"/_next/static/media/built_in_icon.f4837374.svg","height":92,"width":89,"blurWidth":0,"blurHeight":0};